import { render, staticRenderFns } from "./particulars.vue?vue&type=template&id=72a6adf1&scoped=true"
import script from "./particulars.vue?vue&type=script&lang=js"
export * from "./particulars.vue?vue&type=script&lang=js"
import style0 from "./particulars.vue?vue&type=style&index=0&id=72a6adf1&prod&scoped=true&lang=css"
import style1 from "./particulars.vue?vue&type=style&index=1&id=72a6adf1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a6adf1",
  null
  
)

export default component.exports